import posthog from 'posthog-js'
import * as Sentry from '@sentry/react'

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isDev = !import.meta.env.PROD;

if (isDev || isLocalhost) {
  console.log('[PostHog] ✓ Development/localhost mode - PostHog not initialized');
} else {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://app.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
  });

  /**
   * Bridge PostHog session replay to Sentry
   * Attaches PostHog session URL to all Sentry error events
   */
  const setupPostHogSentryIntegration = () => {
    // Set up initial context
    const sessionId = posthog.get_session_id();
    if (sessionId) {
      const postHogHost = import.meta.env.VITE_POSTHOG_HOST ?? 'https://app.posthog.com';
      const sessionUrl = `${postHogHost}/replay/${sessionId}`;

      Sentry.setContext('posthog', {
        session_url: sessionUrl,
        session_id: sessionId,
      });
    }

    // Update context periodically to handle session ID changes
    const interval = setInterval(() => {
      const newSessionId = posthog.get_session_id();
      if (newSessionId) {
        const postHogHost = import.meta.env.VITE_POSTHOG_HOST ?? 'https://app.posthog.com';
        const sessionUrl = `${postHogHost}/replay/${newSessionId}`;

        Sentry.setContext('posthog', {
          session_url: sessionUrl,
          session_id: newSessionId,
        });
      }
    }, 5000); // Update every 5 seconds

    return () => clearInterval(interval);
  };

  // Initialize integration
  setupPostHogSentryIntegration();
}

export default posthog
